import { BaseTextMergeContainerElement } from "../BaseTextMergeContainerElement";
import { TextMergeConfiguration } from "../../TextMergeConfiguration";
import { TextMergeType } from "../../TextMergeType";

export class CodeElement extends BaseTextMergeContainerElement {
    readonly __type = "code";
    readonly name = "Code section";
    readonly styleElement: boolean = true;
    readonly ordinal: number = 10;

    getHTMLTag(): string {
        return "code";
    }

    canAdd(config: TextMergeConfiguration): boolean {
        return config.type === TextMergeType.HTML;
    }
}
